import React from "react";
import Agent from "./agent.jsx";
export const getDashboardData = async (shopId, date) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");

  return await requests.get(
    `/dashboard?shopId=${shopId}&date=${date}`,
    token,
    shopId
  );
};
